module.exports = __webpack_public_path__ + "static/media/sykkel-blue-min.165189f8.png";